import Api from "../config/Axios";
import moment from "moment";


export const getWorkList = (token, user_id, headers) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/work/list", config);
};

export const getWorkFiltersPagination = (token, user_id, pagination = {}, signal = null) => {
  const headers = {
    Authorization: "Bearer " + (token || localStorage.getItem("token")),
    UserId: parseInt(user_id || localStorage.getItem("user_id")),
  };

  const params = [];

  const page = pagination.page || 1;
  const limit = pagination.limit || 100;

  if (pagination.keyword) params.push(`keyword=${pagination.keyword}`);
  if (pagination.status) params.push(`status=${pagination.status}`);
  if (pagination.storeId) params.push(`storeId=${pagination.storeId}`);
  if (pagination.orderId) params.push(`orderId=${pagination.orderId}`);

  // Safe date handling
  if (pagination.orderCreationDate?.length === 2) {
    const from = moment(pagination.orderCreationDate[0]).format("YYYY-MM-DD");
    const to = moment(pagination.orderCreationDate[1]).format("YYYY-MM-DD");
    params.push(`orderCreationDateFrom=${from}`);
    params.push(`orderCreationDateTo=${to}`);
  }

  if (pagination.packedDate?.length === 2) {
    params.push(`packedDateFrom=${moment(pagination.packedDate[0]).format("YYYY-MM-DD")}`);
    params.push(`packedDateTo=${moment(pagination.packedDate[1]).format("YYYY-MM-DD")}`);
  }

  if (pagination.picturePackedDate?.length === 2) {
    params.push(`picturePackedDateFrom=${moment(pagination.picturePackedDate[0]).format("YYYY-MM-DD")}`);
    params.push(`picturePackedDateTo=${moment(pagination.picturePackedDate[1]).format("YYYY-MM-DD")}`);
  }

  params.push(`page=${page}`);
  params.push(`limit=${limit}`);

  const queryString = params.join("&");
  const url = `api/web/work/list?${queryString}`;

  return Api.get(url, { headers, signal });
};

const getApprovalHistoryFilterParams = (pagination = {}) => {
  const params = [];
  if (pagination.storeId) params.push(`storeId=${encodeURIComponent(pagination.storeId)}`);
  if (pagination.orderId) params.push(`orderId=${encodeURIComponent(pagination.orderId)}`);
  if (pagination.itemSku) params.push(`itemSku=${encodeURIComponent(pagination.itemSku)}`);

  const dateRange = pagination.orderCreationDate;
  const from = moment(dateRange?.[0] || undefined).startOf("day").toISOString();
  const to = moment(dateRange?.[1] || undefined).endOf("day").toISOString();
  params.push(`from=${encodeURIComponent(from)}`);
  params.push(`to=${encodeURIComponent(to)}`);
  return params;
};

export const getApprovalHistory = (token, user_id, pagination = {}, signal = null) => {
  const headers = {
    Authorization: "Bearer " + (token || localStorage.getItem("token")),
    UserId: parseInt(user_id || localStorage.getItem("user_id")),
  };

  const params = getApprovalHistoryFilterParams(pagination);
  params.push(`page=${pagination.page || 1}`);
  params.push(`limit=${pagination.limit || 10}`);

  return Api.get(`api/web/work/approval-history?${params.join("&")}`, { headers, signal });
};

export const exportApprovalHistory = (token, user_id, pagination = {}) => {
  const headers = {
    Authorization: "Bearer " + (token || localStorage.getItem("token")),
    UserId: parseInt(user_id || localStorage.getItem("user_id")),
  };

  const params = getApprovalHistoryFilterParams(pagination);
  return Api.get(`api/web/work/approval-history/export?${params.join("&")}`, {
    headers,
    responseType: "blob",
  });
};


export const getWorkDetail = (workId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/work/list-by-id/${workId}`, config);
};

export const getPicturePackedTime = (orderRef, payload, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer ' + (token || localStorage.getItem("token")),
      UserId: parseInt(user_id || localStorage.getItem("user_id")),
      "Content-Type": "application/json",
    },
  };

  return Api.post(`api/web/work/picture-packed-time/${orderRef}`, payload, config);
};

export const getTaskByOrderId = (orderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer ' + (token || localStorage.getItem("token")),
      UserId: parseInt(user_id || localStorage.getItem("user_id")),
    },
  };

  return Api.get(`api/web/tasks/${orderId}`, config);
};

export const releaseWorkApi = (workId, status, type, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer ' + (token || localStorage.getItem("token")),
      UserId: parseInt(user_id || localStorage.getItem("user_id")),
      'Content-Type': 'application/json'
    },
  };

  const data = {
    workId: workId,
    status: status, // e.g., "open" or whatever status you want to send
    type: type,
  };

  return Api.post(`api/web/work`, data, config);
};

export const orderQtyApi = (payload, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer ' + (token || localStorage.getItem("token")),
      UserId: parseInt(user_id || localStorage.getItem("user_id")),
      'Content-Type': 'application/json',
    },
  };

  return Api.post(`api/web/work/actual-qty`, payload, config);
};

export const approveWorkApi = (orderId, status, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer ' + (token || localStorage.getItem("token")),
      UserId: parseInt(user_id || localStorage.getItem("user_id")),
      'Content-Type': 'application/json'
    },
  };

  const data = {
    orderId: orderId,
    status: status,
  };
  return Api.post(`api/web/work/aprroval`, data, config);
};

export const approveBulkPartialWorkApi = (items, token, user_id) => {  
  const config = {
    headers: {
      Authorization: 'Bearer ' + token,
      UserId: user_id,
      'Content-Type': 'application/json',
    },
  };
  return Api.post(
    "api/web/work/aprroval-partail-bulk",
    { items },
    config
  );
};

export const getItemLevelInventoryFiltersPagination = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization: 'Bearer ' + (token || localStorage.getItem("token")),
      UserId: parseInt(user_id || localStorage.getItem("user_id")),
      'Content-Type': 'application/json'
    },
  };

  return Api.post(`api/web/item-level-inventory`, data, config);
};
